export default __webpack_public_path__ + "static/media/sellIcon.9178d306.png";